import React, { memo } from 'react';
import PropTypes from 'prop-types';

import Svg from './Svg';

const InfoBox = ({ title, info }) => {
  const getDescription = () => {
    if (typeof info === 'string') {
      return <p>{info}</p>;
    }

    return info.map((line) => <p>{line}</p>);
  };

  return (
    <div className="row justify-content-center">
      <div className="col-12 col-lg-10 col-xl-8">
        <div className="info-box-container">
          <div className="info-box mt-3">
            <div className="icon">
              <Svg name="info-icon" />
            </div>
            <div className="info-box-content">
              <div className="info-content-inner">
                {title && <h5>{title}</h5>}
                <>{getDescription()}</>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

InfoBox.propTypes = {
  title: PropTypes.string,
  info: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
};

InfoBox.defaultProps = {
  title: null,
};

export default memo(InfoBox);
